__turbopack_context__.v({
  "assumption": "zEjPUq_assumption",
  "block": "zEjPUq_block",
  "breakEven": "zEjPUq_breakEven",
  "headline": "zEjPUq_headline",
  "label": "zEjPUq_label",
  "note": "zEjPUq_note",
  "scenario": "zEjPUq_scenario",
  "scenarioList": "zEjPUq_scenarioList",
  "scenarioRate": "zEjPUq_scenarioRate",
  "scenarios": "zEjPUq_scenarios",
  "told": "zEjPUq_told",
});
